import { format, fromUnixTime } from "date-fns";
import React, { Component, Fragment } from "react";
import { MdArrowBack, MdClose } from "react-icons/md";
import { connect } from "react-redux";
import {
  firebaseConnect,
  firestoreConnect,
  withFirestore,
} from "react-redux-firebase";
import { toastr } from "react-redux-toastr";
import { compose } from "redux";
import { Field, reduxForm } from "redux-form";
import { combineValidators, isRequired } from "revalidate";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon,
  ListGroupItem,
  NavLink,
  Row,
} from "shards-react";
import DateInput from "../../../../common/form/DateInput";
import { EXPECTED } from "../../../../common/form/expected.data";
import SelectInput from "../../../../common/form/SelectInput";
import { STATE_DATA } from "../../../../common/form/states.data";
import TextAreaInput from "../../../../common/form/TextAreaInput";
import TextInput from "../../../../common/form/TextInput";
import { closeModal, openModal } from "../../../../common/modals/modalActions";
import { deleteItem } from "../../../Admin/adminActions";
import {
  addAgent,
  cancelToggle,
  createComplaint,
  updateComplaint,
  updateComplaintArray,
  updateSector,
} from "../complaintActions";
import "./AddComplaint.scss";
import { calculateAgeFromNRIC } from "../../../../common/util/getAgeFromIC";

const mapState = (state, ownProps) => {
  const profile = state.firebase.profile;
  const sectors = state.firebase.ordered.sectors;
  const agents = state.firestore.ordered.agents;
  const categories = state.firebase.ordered.categories;
  const subcategories = state.firebase.ordered.subcategories;
  const documents = state.firestore.ordered.documents;
  const response = state.firestore.data.complaint || undefined;
  const users = state.firestore.data.users;

  //const loading = state.async.loading;
  // let documents = state.firestore.ordered.documents || [];
  let complaint = {};

  if (response !== undefined) {
    complaint = response;
  }

  const complaintTypes = state.firebase.ordered.complaintTypes ?  state.firebase.ordered.complaintTypes.sort((a,b)=> a.value.name.localeCompare(b.value.name)) : [];

  return {
    initialValues: complaint,
    complaint,
    profile,
    users,
    complaintTypes,
    agents,
    categories,
    documents,
    sectors,
    subcategories,
    //documents: documents
  };
};
const actions = {
  createComplaint,
  updateComplaint,
  cancelToggle,
  updateSector,
  addAgent,
  deleteItem,
  updateComplaintArray,
  closeModal,
  openModal,
};

const validate = combineValidators({
  companyName: isRequired({ message: "company name is required" }),
  companyAddress1: isRequired("company Address"),
  reportDate: isRequired("reportDate"),
  companyAddressState: isRequired("company state"),
  companyTel: isRequired("company contact number"),
});

class AddComplaint extends Component {
  state = {
    statesArray: STATE_DATA,
    expectedArray: EXPECTED,
    incideDateEdit: false,
    reportDateEdit: false,
    complaintType: "",
    complainant: "",
    sector: "",
    category: "",
    subcategory: "",
    closingNote: "",
    subcategories: [],
    agent: {
      displayName: "",
      role: "",
      uid: "",
    },
    note: "",
    complainantError: "",
    age: calculateAgeFromNRIC()
  };

  async componentDidMount() {
    const { firestore, match, history } = this.props;
    let complaint = await firestore.get(`complaints/${match.params.id}`);

    if (!complaint.exists) {
      history.push("/dashboard/main");
      toastr.error("Sorry", "Complaint not found");
    } else {
    }
  }

  handleSectorSubmit = () => {
    let payload = {
      sector: this.state.sector,
      category: this.state.category,
      subcategory: this.state.subcategory,
    };

    this.props.updateSector(this.props.complaint, payload);
    this.setState({ sector: "", categories: "", subcategories: "" });
  };

  handleCreateComplaint = (values) => {
    if (this.props.initialValues.id) {
      this.props.updateComplaint(values);
      // this.props.history.push(
      //   `/dashboard/complaintsDetails/${this.props.initialValues.id}`,
      // );
    } else {
      this.props.createComplaint(values);
    }
  };

  handleSelect = (e) => {
    //console.log(e.target.name);
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.name === "category") {
      //console.log(this.props);
      if (this.props.subcategories.length > 0) {
        this.setState({
          subcategories: this.props.subcategories.filter(
            (item) => item.category === e
          ),
        });
      }
    }
  };

  handleSector = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleComplaintTypeSubmit = () => {
    let newComplaint = { ...this.props.complaint };
    newComplaint.complaintType = this.state.complaintType;

    this.props.updateComplaint(newComplaint);
  };

  handleAgentSubmit = () => {
    const { uid, displayName, email, role } = JSON.parse(this.state.agent);
    this.props.addAgent(this.props.complaint, {
      uid,
      displayName,
      email,
      role,
    });
    this.setState({ agent: { displayName: "", role: "", uid: "" } });
  };

  handleChange = (e) => {
    console.log(e.target.name);
    this.setState({ [e.target.name]: e.target.value });
  };

  handleNotes = () => {
    let note = {
      message: this.state.note,
      date: new Date().toDateString(),
    };

    this.props.updateComplaintArray(
      this.props.complaint.id,
      "notes",
      note,
      "add"
    );

    this.setState({ note: "" });
  };

  handleCloseComplaint = (note, complaint) => {
    let newComplaint = { ...complaint };

    console.log(newComplaint);
    //Change status from processing to closed
    newComplaint.status = "closed";

    // Add closing note for sending out email to complainant
    newComplaint.closingNote = this.state.closingNote;
    let user = {
      name: this.props.profile.userFullName,
      uid: this.props.profile.uid,
      email: this.props.profile.email,
      date: new Date(),
    };
    newComplaint.closedBy = user;
    newComplaint.closedBy.date = new Date();

    console.log("USER CLOSE: ", user);

    //Add notes to the notes array
    this.handleNotes();

    // Update complaint with the updates
    this.props.updateComplaint(newComplaint);
    this.props.closeModal();
  };

  getComplainant = (complaint) => {
    // console.log(complaint);
    if (complaint) {
      this.props.firestore
        .get(`users/${complaint.complainant.uid}`)
        .then((data) => {
          if (this.props.users && this.props.users[complaint.complainant.uid]) {
            this.setState({
              complainant: this.props.users[complaint.complainant.uid],
            });
          } else {
            //console.log('trigger2');
            this.setState({
              complainantError: "Complainant profile not found",
            });
          }
        })
        .catch((err) => {
          //console.error(err);
          this.setState({ complainantError: "Complainant profile not found" });
        });
    }
  };

  checkUserRole = (type, name, options) => {
    if (this.props.profile.role === "complainant") {
      let comp;

      switch (type) {
        case "text":
          comp = TextInput;
          return (
            <Field component={comp} type={type} name={name} placeholder={""} />
          );

        case "select":
          comp = SelectInput;
          return (
            <Field
              component={comp}
              type={type}
              name={name}
              placeholder={""}
              options={options}
            />
          );

        default:
          comp = TextInput;
          return (
            <Field component={comp} type={type} name={name} placeholder={""} />
          );
      }
    } else {
      if (type === "email") {
        return <div className="">{this.props.complaint[name]}</div>;
      } else {
        return (
          <div className="text-capitalize">{this.props.complaint[name]}</div>
        );
      }
    }
  };

  render() {
    const {
      statesArray,
      expectedArray,
      incideDateEdit,
      complainant,
      closingNote,
      complainantError,
    } = this.state;
    const {
      submitting,
      pristine,
      cancelToggle,
      complaint,
      history,
      profile,
      complaintTypes,
      sectors,
      categories,
      subcategories,
      agents,
      documents,
      updateComplaintArray,
    } = this.props;
    return (
      <Container fluid>
        <Card className="my-2" small>
          <CardHeader className="border-bottom card-header bg-primary d-flex align-items-center">
            <NavLink
              onClick={() => history.goBack()}
              className="text-white float-left"
            >
              <MdArrowBack className="text-white" /> Back
            </NavLink>

            <h5 className="m-0 text-center">Edit Complaint</h5>
          </CardHeader>

          <Form onSubmit={this.props.handleSubmit(this.handleCreateComplaint)}>
            <ListGroupItem>
              <strong>Ticket Details</strong>
              <Row>
                <Col>Ticket ID: {complaint.id}</Col>
                <Col className="text-capitalize">
                  Status: {complaint.status}
                </Col>
              </Row>
              <Row>
                <Col>
                  Date:
                  {complaint.created && complaint.created._seconds
                    ? fromUnixTime(complaint.created._seconds).toDateString()
                    : format(complaint.created.toDate(), "dd MMM yyyy")}
                </Col>
              </Row>
            </ListGroupItem>

            <ListGroupItem>
              <strong>Sector</strong>

              {(complaint.sectors && complaint.sectors.length > 0) ||
              (complaint.categories && complaint.categories.length > 0) ||
              (complaint.subcategories &&
                complaint.subcategories.length > 0) ? (
                <Fragment>
                  <table className="table mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0 ">
                          Sectors
                        </th>
                        <th scope="col" className="border-0">
                          Categories
                        </th>
                        <th scope="col" className="border-0">
                          Subcategories
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {complaint.sectors &&
                            complaint.sectors.map((sector, index) => (
                              <div
                                className="text-dark text-capitalize"
                                key={sector}
                              >
                                {sector}
                                {profile.role === "manager" ||
                                profile.role === "agent" ||
                                profile.role === "temp-agent" ? (
                                  <MdClose
                                    className="text-danger float-right"
                                    onClick={() =>
                                      updateComplaintArray(
                                        complaint.id,
                                        "sectors",
                                        sector,
                                        "remove"
                                      )
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            ))}
                        </td>
                        <td>
                          {complaint.categories &&
                            complaint.categories.map((category, index) => (
                              <div
                                className="text-dark text-capitalize"
                                key={category}
                              >
                                {category}
                                {profile.role === "manager" ||
                                profile.role === "agent" ||
                                profile.role === "temp-agent" ? (
                                  <MdClose
                                    className="text-danger float-right"
                                    onClick={() =>
                                      updateComplaintArray(
                                        complaint.id,
                                        "categories",
                                        category,
                                        "remove"
                                      )
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            ))}
                        </td>
                        <td>
                          {complaint.subcategories &&
                            complaint.subcategories.map(
                              (subcategory, index) => (
                                <div
                                  className="text-dark text-capitalize"
                                  key={subcategory}
                                >
                                  {subcategory}
                                  {profile.role === "manager" ||
                                  profile.role === "agent" ||
                                  profile.role === "temp-agent" ? (
                                    <MdClose
                                      className="text-danger float-right"
                                      onClick={() =>
                                        updateComplaintArray(
                                          complaint.id,
                                          "subcategories",
                                          subcategory,
                                          "remove"
                                        )
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Fragment>
              ) : (
                <div>Sector not assigned</div>
              )}

              {(profile.role === "manager" || profile.role === "agent") && (
                <Row>
                  <Col>
                    <FormGroup>
                      <label htmlFor="username">Select Sector</label>
                      <FormSelect
                        name="sector"
                        value={this.state.sector}
                        onChange={this.handleSector}
                      >
                        <option key="0" value="" />
                        {sectors &&
                          sectors.length > 0 &&
                          sectors.map((sector) => (
                            <option key={sector.value} value={sector.value}>
                              {sector.value}
                            </option>
                          ))}
                      </FormSelect>
                    </FormGroup>
                    <Button
                      theme="success"
                      disabled={
                        this.state.sector === "" || this.state.category === ""
                      }
                      onClick={() => this.handleSectorSubmit()}
                    >
                      Submit
                    </Button>
                  </Col>
                  <Col>
                    <FormGroup>
                      <label htmlFor="category">Category</label>
                      <FormSelect
                        name="category"
                        value={this.state.category}
                        onChange={this.handleSelect}
                      >
                        <option key="0" value="" />
                        {categories &&
                          categories.length > 0 &&
                          categories
                            .filter(
                              (category) =>
                                category.value.sector === this.state.sector
                            )
                            .map((category) => (
                              <Fragment>
                                <option
                                  key={category.key}
                                  value={category.value.name}
                                >
                                  {category.value.name}
                                </option>
                              </Fragment>
                            ))}
                      </FormSelect>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <label htmlFor="subcategory">Subcategory</label>
                      <FormSelect
                        name="subcategory"
                        value={this.state.subcategory}
                        onChange={this.handleSelect}
                      >
                        <option key="0" value="" />
                        {subcategories &&
                          subcategories.length > 0 &&
                          subcategories
                            .filter(
                              (category) =>
                                category.value.category === this.state.category
                            )
                            .map((category) => (
                              <Fragment>
                                <option
                                  key={category.key}
                                  value={category.value.name}
                                >
                                  {category.value.name}
                                </option>
                              </Fragment>
                            ))}
                      </FormSelect>
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </ListGroupItem>
            {profile.role === "agent" ||
            (profile.role === "temp-agent") | (profile.role === "manager") ? (
              <ListGroupItem>
                <strong>Complaint Type</strong>
                <InputGroup>
                  <FormSelect
                    name="complaintType"
                    value={this.state.complaintType}
                    onChange={this.handleSector}
                  >
                    <option key="0" value="" />
                    {complaintTypes &&
                      complaintTypes.length > 0 &&
                      complaintTypes
                        .filter(
                          (type) =>
                            type.value.sector === complaint.sectors[0] || ""
                        )
                        .map((category) => (
                          <option
                            key={category.value.name}
                            value={category.value.name}
                          >
                            {category.value.name}
                          </option>
                        ))}
                  </FormSelect>

                  <InputGroupAddon type="append">
                    <Button
                      theme="success"
                      disabled={this.state.complaintType === ""}
                      onClick={() => this.handleComplaintTypeSubmit()}
                    >
                      Submit
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </ListGroupItem>
            ) : (
              ""
            )}
            <ListGroupItem>
              <strong>Agent</strong>
              {complaint.agent.name !== "" ? (
                <Fragment>
                  <table className="table mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0 ">
                          Name
                        </th>

                        <th scope="col" className="border-0">
                          Email
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-capitalize">
                          {complaint.agent.displayName}
                        </td>

                        <td>{complaint.agent.email}</td>
                      </tr>
                    </tbody>
                  </table>
                </Fragment>
              ) : (
                <div> Agent not assigned</div>
              )}
              {profile.role === "manager" ? (
                <Row>
                  <Col>
                    <InputGroup className="mt-2">
                      <FormSelect
                        name="agent"
                        value={this.state.agent}
                        onChange={this.handleSelect}
                      >
                        <option key="0" value="" />
                        {agents &&
                          agents.length > 0 &&
                          agents.map((agent) => (
                            <Fragment>
                              <option
                                key={agent.uid}
                                value={JSON.stringify(agent)}
                              >
                                {agent.displayName}
                              </option>
                            </Fragment>
                          ))}
                      </FormSelect>

                      <InputGroupAddon type="append">
                        <Button
                          theme="success"
                          disabled={this.state.agent.uid === ""}
                          onClick={() => this.handleAgentSubmit()}
                        >
                          Submit
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </Col>
                </Row>
              ) : (
                " "
              )}
            </ListGroupItem>

            <ListGroupItem>
              <strong>Company Details</strong>
              <Row form>
                <Col className="form-group">
                  <FormGroup>
                    <label htmlFor="companyName">Company Name</label>
                    {this.checkUserRole("text", "companyName")}
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <label htmlFor="companyEmail">Company Email</label>
                    {this.checkUserRole("email", "companyEmail")}
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col className="form-group">
                  <FormGroup>
                    <label htmlFor="companyAddress1">Company Address1</label>
                    {this.checkUserRole("text", "companyAddress1")}
                  </FormGroup>
                </Col>
                <Col className="form-group">
                  <FormGroup>
                    <label htmlFor="companyAddress2">Company Address2</label>
                    {this.checkUserRole("text", "companyAddress2")}
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md="4" className="form-group">
                  <label htmlFor="companyAddressTown">Town</label>
                  {this.checkUserRole("text", "companyAddressTown")}
                </Col>
                <Col md="6" className="form-group">
                  <label htmlFor="companyAddressState">State</label>
                  {this.checkUserRole(
                    "select",
                    "companyAddressState",
                    statesArray
                  )}
                </Col>
                <Col md="2">
                  <label htmlFor="companyAddressPostCode">Post Code</label>
                  {this.checkUserRole("text", "companyAddressPostCode")}
                </Col>
              </Row>
              <Row form>
                <Col className="form-group">
                  <label htmlFor="companyTel">Contact Number</label>
                  <div>{complaint.companyTel}</div>
                </Col>
              </Row>
            </ListGroupItem>
            <ListGroupItem>
              <strong>Complainant</strong>
              <Row>
                <Col lg="4" md="6">
                  Name : {complaint.createdBy}
                </Col>
                <Col lg="4" md="6">
                  Email: {complaint.complainant.email}
                </Col>

                {complainant && complainant !== "" ? (
                  <Fragment>
                    <Col lg="4" md="6" className="mt-1 text-capitalize">
                      National ID: {complainant.userNationalId}
                    </Col>
                    <Col lg="4" md="6" className="mt-1 text-capitalize">
                      Nationality: {complainant.userCitizenship}
                    </Col>
                    <Col lg="4" md="6" className="mt-1 text-capitalize">
                      Gender: {complainant.userGender}
                    </Col>

                    <Col lg="4" md="6" className="mt-1 text-capitalize">
                      Contact: {complainant.userMobile}
                    </Col>

                    <Col lg="4" md="6" className="mt-1 text-capitalize">
                      Address: {complainant.userAddress1},{" "}
                      {complainant.userAddress2},{complainant.userAddressTown},{" "}
                      {complainant.userAddressPostCode},
                      {complainant.userAddressState}, Malaysia
                    </Col>
                  </Fragment>
                ) : (
                  ""
                )}
              </Row>
              {complainantError && complainantError !== "" ? (
                <div className="text-danger">{complainantError}</div>
              ) : (
                ""
              )}

              {profile.role === "agent" ||
              profile.role === "temp-agent" ||
              profile.role === "manager" ? (
                <Button
                  onClick={() => this.getComplainant(complaint)}
                  className="mt-2"
                  disabled={complainant !== ""}
                >
                  Lookup Complainant
                </Button>
              ) : (
                ""
              )}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Complaint Details</strong>
              {profile.role === "complainant" ? (
                <Button
                  className="float-right"
                  onClick={() =>
                    this.setState({ incideDateEdit: !incideDateEdit })
                  }
                >
                  Edit
                </Button>
              ) : (
                ""
              )}

              <Row form>
                <Col className="form-group">
                  <FormGroup>
                    <label htmlFor="complaintDetails">Complaint</label>

                    <Field
                      component={TextAreaInput}
                      rows={5}
                      type="textarea"
                      name="complaintDetails"
                      placeholder="I was cheated..."
                      disabled={profile.role !== "complainant"}
                    />
                  </FormGroup>
                  <span>
                    Do not share any sensitive information such as nationalID,
                    credit card numbers and etc.
                  </span>
                </Col>
              </Row>
              <Row>
                <Col className="form-group">
                  <label>Incident Date</label>
                  {incideDateEdit ? (
                    <FormGroup>
                      <Field
                        type="date"
                        name="incidentDate"
                        component={DateInput}
                      />
                    </FormGroup>
                  ) : (
                    <div>
                      {format(complaint.incidentDate.toDate(), "dd MMM yyyy")}
                    </div>
                  )}
                </Col>
                <Col className="form-group">
                  <label>Report Date</label>
                  {incideDateEdit ? (
                    <FormGroup>
                      <Field
                        type="date"
                        name="reportDate"
                        component={DateInput}
                      />
                    </FormGroup>
                  ) : (
                    <div>
                      {format(complaint.reportDate.toDate(), "dd MMM yyyy")}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col className="form-group">
                  <FormGroup>
                    <label>Estimated Loss, RM</label>
                    {incideDateEdit ? (
                      <Field
                        name="estimated_loss "
                        type="text"
                        component={TextInput}
                      />
                    ) : (
                      <div>RM {complaint.estimated_loss}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col className="form-group">
                  <FormGroup>
                    <label>Reply Status</label>
                    {incideDateEdit ? (
                      <Field name="replyStatus" component={TextInput} />
                    ) : (
                      <div>{complaint.replyStatus}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col className="form-group">
                  <FormGroup>
                    <label>Expect Outcome</label>
                    {incideDateEdit ? (
                      <Field
                        name="expectedOutcome"
                        component={SelectInput}
                        options={expectedArray}
                        type="text"
                      />
                    ) : (
                      <div>{complaint.expectedOutcome}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </ListGroupItem>
            {documents && documents.length > 0 ? (
              <ListGroupItem>
                <strong>Attachments</strong>
                {documents.map((document) => {
                  return (
                    <div>
                      <a
                        href={document.fileUrl}
                        className="text-primary"
                        target="__blank"
                      >
                        {document.fileName}
                      </a>
                    </div>
                  );
                })}
              </ListGroupItem>
            ) : (
              ""
            )}
            {profile.role === "agent" ||
            profile.role === "temp-agent" ||
            profile.role === "manager" ? (
              <ListGroupItem>
                <strong>Notes</strong>

                <FormGroup>
                  {complaint.notes && complaint.notes.length > 0
                    ? complaint.notes.map((note, index) => (
                        <div className="d-flex" key={index}>
                          {note.date && note.date}:
                          <div className="titleCase ml-1"> {note.message}</div>
                          {profile.role === "agent" ||
                          profile.role === "temp-agent" ? (
                            <MdClose
                              className="text-danger float-right"
                              onClick={() =>
                                updateComplaintArray(
                                  complaint.id,
                                  "notes",
                                  note,
                                  "remove"
                                )
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      ))
                    : ""}

                  <InputGroup className="mt-2">
                    <FormInput
                      name="note"
                      onChange={(e) => this.handleChange(e)}
                      value={this.state.note}
                      placeholder="Enter a note here"
                    />
                    <InputGroupAddon type="append">
                      <Button
                        theme="success"
                        disabled={this.state.note === ""}
                        onClick={() => {
                          this.handleNotes();
                        }}
                      >
                        Submit
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </ListGroupItem>
            ) : (
              ""
            )}

            <ListGroupItem>
              <div className="home-buttons d-flex w-100 justify-content-between">
                <Button
                  onClick={() => history.goBack()}
                  className="text-white float-left"
                  theme="danger"
                >
                  <MdArrowBack className="text-white" /> Cancel Edit
                </Button>

                {profile.role === "agent" ||
                profile.role === "temp-agent" ||
                profile.role === "manager" ? (
                  <Button
                    onClick={() => {
                      this.props.openModal("CloseComplaint", {
                        closeModal: this.props.closeModal,
                        complaint: complaint,
                        note: this.state.note,
                        closingNote: this.state.closingNote,
                        handleChange: this.handleChange,
                        handleCloseComplaint: this.handleCloseComplaint,
                      });
                    }}
                    className="text-white float-left"
                    theme="danger"
                  >
                    Close Complaint
                  </Button>
                ) : (
                  ""
                )}

                {profile.role === "manager" ||
                profile.role === "agent" ||
                profile.role === "temp-agent" ? (
                  ""
                ) : (
                  <Fragment>
                    <Button
                      onClick={() =>
                        cancelToggle(!complaint.cancelled, complaint.id)
                      }
                      theme={complaint.cancelled ? "primary" : "warning"}
                    >
                      {complaint.cancelled ? "Reenable" : "Retract Complaint"}
                    </Button>
                    <Button
                      type="submit"
                      theme="success"
                      disabled={submitting || pristine}
                    >
                      Submit
                    </Button>
                  </Fragment>
                )}
              </div>
            </ListGroupItem>
          </Form>
        </Card>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  withFirestore,
  firebaseConnect((props) => {
    if (
      props.profile.role === "manager" ||
      props.profile.role === "agent" ||
      props.profile.role === "temp-agent"
    ) {
      return [
        { path: "/sectors", queryParams: ["orderByValue"], storeAs: "sectors" },
        {
          path: "/categories",
          queryParams: ["orderByValue"],
          storeAs: "categories",
        },
        {
          path: "/subcategories",
          queryParams: ["orderByValue"],
          storeAs: "subcategories",
        },
        {
          path: "/complaintTypes",
          queryParams: ["orderByValue"],
          storeAs: "complaintTypes",
        },
      ];
    } else {
      return [];
    }
  }),
  firestoreConnect((props) => {
    if (props.profile.role === "manager") {
      return [
        {
          collection: "agents",
          storeAs: "agents",
        },

        {
          collection: "complaints",
          doc: props.complaint.id,
          storeAs: "complaint",
        },
      ];
    }

    if (props.profile.role === "agent" || props.profile.role === "temp-agent") {
      return [
        {
          collection: "complaints",
          doc: props.complaint.id,
          storeAs: "complaint",
        },
      ];
    } else {
      return [];
    }
  }),
  reduxForm({ form: "editForm", validate })
)(AddComplaint);
